// Serialización del problema para guardar/cargar (JSON) y compartir por URL.

export interface SavedState {
  mode: 'transporte' | 'asignacion';
  m: number;
  n: number;
  costs: number[][];
  supply: number[];
  demand: number[];
  sources: string[];
  dests: string[];
  forbidden: boolean[][];
  maximize: boolean;
  method: 'noroeste' | 'costo';
}

const STORAGE_KEY = 'transporte-state';

// Codifica a base64 seguro para URL (maneja caracteres UTF-8).
function toBase64(str: string): string {
  return btoa(unescape(encodeURIComponent(str)));
}
function fromBase64(b64: string): string {
  return decodeURIComponent(escape(atob(b64)));
}

export function encodeToHash(state: SavedState): string {
  return '#d=' + toBase64(JSON.stringify(state));
}

export function decodeFromHash(): SavedState | null {
  const h = window.location.hash;
  if (!h.startsWith('#d=')) return null;
  try {
    return JSON.parse(fromBase64(h.slice(3))) as SavedState;
  } catch {
    return null;
  }
}

export function saveLocal(state: SavedState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* almacenamiento no disponible */
  }
}

export function loadLocal(): SavedState | null {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    return s ? (JSON.parse(s) as SavedState) : null;
  } catch {
    return null;
  }
}

export function downloadJson(state: SavedState): void {
  const blob = new Blob([JSON.stringify(state, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'problema-transporte.json';
  a.click();
  URL.revokeObjectURL(url);
}
